import { render } from "./SignInRegesSSO.vue?vue&type=template&id=79b8e37b"
import script from "./SignInRegesSSO.vue?vue&type=script&lang=ts"
export * from "./SignInRegesSSO.vue?vue&type=script&lang=ts"
script.render = render

export default script